import { connect } from 'react-redux';
import ModuleLoadingBase from './ModuleLoadingBase';
function mapStateToProps(state) {
  return {
    theme: state.ui.theme.currentTheme || state.ui.theme.defaultTheme
  };
}
export default connect(mapStateToProps)(ModuleLoadingBase);